import { useSubscription } from "@apollo/client";
import { EXTERNAL_SIGN_REGISTRATION_SIGNED_SUBSCRIPTION } from "@/modules/gateway/features/open-external-sign/api/external-sign-registration-signed-subscription";

export function useExternalSignRegistrationSignedSubscription({
  code,
}: {
  code?: string;
}) {
  const { data, loading } = useSubscription(
    EXTERNAL_SIGN_REGISTRATION_SIGNED_SUBSCRIPTION,
    {
      variables: {
        code: code as string,
      },
      skip: !code,
    },
  );

  return {
    signStatus: data?.externalSignRegistrationStatusSubscription,
    loading,
  };
}
